var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    attrs: {
      src: _vm.radioStat
        ? "/img/radio/radio-on.png"
        : "/img/radio/radio-off.png",
      alt: ""
    },
    on: { click: _vm.changeRadio }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }